import React, { useState } from 'react';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { Link as RouterLink } from 'react-router-dom';
import { T } from "./Translate";
import {
  Alert,
  Box,
  Button,
  CardContent,
  CardMedia,
  CircularProgress,
  FormControl,
  InputLabel,
  Link,
  OutlinedInput,
  Stack,
  Typography,
  Container
} from '@mui/material';
import { brandColors } from "../theme";
import { functions } from "../firebase";
import logo13 from "../logo13.png";
const logo15 = `${process.env.PUBLIC_URL}/logo15.png`;

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');
    setError('');

    try {
      // Mail por Resend (functions/index.js); si la función falla por otra
      // cosa que el tope de intentos o un email inválido, el de Firebase
      try {
        await functions.httpsCallable('sendPasswordResetEmail')({ email });
      } catch (fnErr) {
        if (/resource-exhausted|invalid-argument/.test(fnErr.code || '')) throw fnErr;
        console.error('Falló el envío por Resend, se usa Firebase:', fnErr);
        await sendPasswordResetEmail(getAuth(), email);
      }
      setMessage(<T>Password reset email sent. Please check your inbox.</T>);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 8, pb: 4 }}>
        <CardMedia component="img" image={brandColors.mode === 'dark' ? logo13 : logo15} title="Notiline" sx={{ width: 180, mx: 'auto', mt: 4, mb: 2 }} />
        <CardContent>
          <Typography variant="h5" textAlign="center" fontWeight="300" gutterBottom>
            <T>Restablecer contraseña</T>
          </Typography>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}

          <Box component="form" onSubmit={handleSubmit} noValidate>
            <FormControl fullWidth margin="normal">
              <InputLabel htmlFor="email"><T>Email</T></InputLabel>
              <OutlinedInput
                id="email"
                type="email"
                label={<T>Email</T>}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="usuario@gmail.com"
                disabled={isLoading}
                autoComplete="email"
                required
              />
            </FormControl>

            <Button type="submit" fullWidth variant="contained" disabled={isLoading} sx={{ mt: 3, height: 42 }}>
              {isLoading ? <CircularProgress size={24} color="inherit" /> : <T>Restablecer contraseña</T>}
            </Button>

            <Stack spacing={1} alignItems="center" sx={{ mt: 2 }}>
              <Typography variant="body2" sx={{ color: brandColors.textSecondary }}>
                <Link component={RouterLink} to="/login" sx={{ color: brandColors.accent }}><T>Volver al inicio de sesión</T></Link>
              </Typography>
            </Stack>
          </Box>
        </CardContent>
      </Box>
    </Container>
  );
};

export default ResetPassword;
